import tailwindColors from '../../../../config/colors'

export const colors = [
  tailwindColors.violet[400],
  tailwindColors.emerald[300],
  tailwindColors.orange[300],
  tailwindColors.teal[300],
  tailwindColors.pink[400],
  tailwindColors.lime[300],
  tailwindColors.purple[400],
  tailwindColors.green[400],
  tailwindColors.yellow[200],
  tailwindColors.blue[300],
  tailwindColors.red[400],
]

export const colors_old = [
  '#27399d',
  '#7f35d4',
  '#74b9ff',
  '#afaac2',
  '#ecc100',
  '#e999d8',
  '#e28e00',
  '#aa8240',
  '#61d8c3',
]

export const colorsPerfChart = [tailwindColors.yellow[300], tailwindColors.teal[400], tailwindColors.purple[400]]
